import { Unit } from './types';
import { UnitError } from './UnitError';

export class AmbiguousConversionError extends UnitError {
  readonly name = 'AmbiguousConversionError';
  constructor(u1: Unit, u2: Unit) {
    super(
      // eslint-disable-next-line @typescript-eslint/no-base-to-string
      `Ambiguous conversion: ${u1} or ${u2} contains multiple sub-units in the same dimension`
    );
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AmbiguousConversionError);
    }
    Object.setPrototypeOf(this, AmbiguousConversionError.prototype);
  }
  static invariant: (b: boolean, u1: Unit, u2: Unit) => asserts b = (
    b,
    u1,
    u2
  ) => {
    if (!b) {
      throw new AmbiguousConversionError(u1, u2);
    }
  };
}
